import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/dark-arbitrary.css";
import App from "@/App";
import { isDrivePath } from "@/lib/drive/head";
import { isSanitarioPath } from "@/lib/sanitario/head";
import { isVisitePath } from "@/lib/visite/head";
import { isOssPath } from "@/lib/oss/head";

// In sviluppo NON registrare il Service Worker: intercetta fetch/cache e su Safari (iPad)
// può dare pagina bianca, HMR rotto o loop di reload (vedi controllerchange sotto).
if (process.env.NODE_ENV !== "production" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  if ("caches" in window) {
    caches.keys().then((keys) =>
      Promise.all(
        keys.filter((k) => String(k).includes("affidya")).map((k) => caches.delete(k))
      )
    );
  }
}

// PWA + aggiornamenti solo dal build di produzione
// Drive, Sanità, Visite e OSS hanno un service worker proprio, registrato dalla shell
// (OSS: mai dentro le app native, vedi src/lib/oss/sw.js).
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator && !isDrivePath(window.location.pathname) && !isSanitarioPath(window.location.pathname) && !isVisitePath(window.location.pathname) && !isOssPath(window.location.pathname)) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("AFFIDYA PWA: Service Worker registrato", registration.scope);

        const checkUpdate = () => registration.update();
        checkUpdate();
        window.addEventListener("focus", checkUpdate);

        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              console.log("AFFIDYA PWA: Nuova versione disponibile");
              window.dispatchEvent(new CustomEvent("sw-update", { detail: { newWorker } }));
            }
          });
        });
      })
      .catch((error) => {
        console.log("AFFIDYA PWA: Errore registrazione Service Worker", error);
      });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
